module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"standardized":"Standardized"},"fr":{"standardized":"Standardisée"}}')
  delete Component.options._Ctor
}
